import { create } from 'zustand';

type NotificationProps = {
  notificationList: {
    top10: [];
    notifications: [];
    totalCount: number;
  };
  loading: boolean;
  error: string | null;
};

type NotificationAction = {
  fetchNotification: (length?: '8' | 'full') => Promise<void>;
};

const useNotificationStore = create<NotificationProps & NotificationAction>(set => ({
  notificationList: {
    top10: [],
    notifications: [],
    totalCount: 0,
  },
  loading: false,
  error: null,

  fetchNotification: async (length = '8'): Promise<void> => {
    set(state => ({ ...state, loading: true, error: null }));

    try {
      const response = await fetch(`/api/notifications?length=${length}`, {
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error('Failed to fetch notifications');
      }

      const data = await response.json();

      set(state => ({
        ...state,
        notificationList:
          length === 'full'
            ? {
                ...state.notificationList,
                notifications: data.notifications || [],
                totalCount: data.totalCount || 0,
              }
            : {
                ...state.notificationList,
                top10: data.notifications || [],
                totalCount: data.totalCount || 0,
              },
        loading: false,
      }));
    } catch (error: any) {
      set(state => ({
        ...state,
        error: error.message || 'An unexpected error occurred',
        loading: false,
      }));
    }
  },
}));

export default useNotificationStore;
